import { useState } from "react";
import { crashOf } from "../../src/feedback/crash.ts";
import { ApiError } from "./api.ts";
import { lastFailure, openFeedback } from "./feedback.ts";

// Report this (features/feedback.md), on an error a request to Tripmo met and on every page that failed: the feedback
// form (Feedback.tsx), a bug, with the request's id (the error's own, or the request that failed as it was shown).
// Not beside what the page says itself before asking anything ("Give the trip a name."), nor with no signal, when
// it couldn't be sent anyway. `line`: on a failed page, a line of its own beside Try again, as Back to your trips is;
// else a link in the error's own words. `always`: on a page that broke, whatever it met. `crash`: what a page, a
// view or the map broke on (crash.tsx), sent as its message and where in Tripmo's code (src/feedback/crash.ts).
export function ReportThis({
  error,
  line = false,
  always = false,
  crash,
}: {
  error?: unknown;
  line?: boolean;
  always?: boolean;
  crash?: { error: unknown };
}) {
  // As it was when the error was shown: the request that failed then.
  const [requestId] = useState(() =>
    error instanceof ApiError ? error.requestId : (lastFailure(SHOWN_WITHIN_MS)?.id ?? null),
  );
  const met = error instanceof ApiError ? error.status >= 400 : requestId !== null;
  if (!always && !met) return null;
  const button = (
    <button
      type="button"
      className={line ? "tm-report tm-report--line body" : "tm-report"}
      onClick={() =>
        openFeedback({ kind: "bug", requestId, crash: crash ? crashOf(crash.error, location.origin) : null })
      }
    >
      Report this
    </button>
  );
  return line ? button : <> {button}</>;
}

// An error shown this soon after a request failed is that request's.
const SHOWN_WITHIN_MS = 10_000;
